import type { ChakraTheme } from "~/foundation/Chakra";

export const radii: ChakraTheme["radii"] = {
	xs: ".25rem",
	sm: ".5rem",
	md: ".75rem",
	lg: "1.125rem",
	xl: "1.5rem",
	xxl: "2rem"
}